import { Typography } from '@mui/material';
import { ODSInlineNotification } from '@telekom-ods/react-ui-kit';
import { type FC } from 'react';
import { useIntl } from 'react-intl';

interface Product {
  _id: string;
  name: string;
  type: string;
}

interface ProductUnassignmentProps {
  resources: {
    products: Product[];
  };
}

const ProductUnassignment: FC<ProductUnassignmentProps> = ({ resources }) => {
  const intl = useIntl();

  return (
    <div
      className='notification-no-close'
      style={{ marginBottom: '1rem' }}
    >
      <ODSInlineNotification
        mode='warning'
        title={intl.formatMessage({ id: 'userUnassignment1' })}
        text={intl.formatMessage({ id: 'userUnassignment2' })}
        opened
        showCloseButton={false}
      />

      <div style={{ marginTop: '0.75rem', paddingLeft: '0.5rem' }}>
        {resources.products.map(product => (
          <Typography key={product._id}>
            • {product.name} ({product.type})
          </Typography>
        ))}
      </div>
    </div>
  );
};

export default ProductUnassignment;
